import {apiClient} from 'core/apiClient';
import {
    TransferDocumentRequest,
    TransferDocumentResponse,
    TransferDocumentStatusResponse,
} from 'types';

const URL = '/marking/transfer-document';
const config = {baseURL: '/api/v2'};

export async function createTransferDocument(body: TransferDocumentRequest) {
    return (await apiClient.post<TransferDocumentResponse>(`${URL}/load`, body, config)).data;
}

export async function updateTransferDocument(reportId: string, body: TransferDocumentRequest) {
    return (
        await apiClient.post<TransferDocumentResponse>(`${URL}/update-body`, body, {
            ...config,
            params: {reportId},
        })
    ).data;
}

export async function fetchTransferDocument(reportId: string) {
    return (
        await apiClient.get<TransferDocumentRequest>(`${URL}/body`, {
            ...config,
            params: {reportId},
        })
    ).data;
}

export async function fetchTransferDocumentStatus(reportId: string) {
    return (
        await apiClient.get<TransferDocumentStatusResponse>(`${URL}/status`, {
            ...config,
            params: {reportId},
        })
    ).data;
}

export async function updateTransferDocumentStatus(reportId: string, reportStatus: string) {
    return (
        await apiClient.post<TransferDocumentResponse>(`${URL}/update-status`, null, {
            ...config,
            params: {reportId, reportStatus},
        })
    ).data;
}
